// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from "vue";
import App from "./App";
import router from "./router";
import { BootstrapVue, IconsPlugin } from "bootstrap-vue";
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-vue/dist/bootstrap-vue.css";
import VueCropper from "vue-cropper";
import Loading from "vue-loading-spin";
import "vue-loading-spin/dist/loading.css";
import "weui";
import infiniteScroll from "vue-infinite-scroll";
import Vuex from "vuex";
import md5 from "js-md5";
//vantUI
import "@/vantUI";
import "vant/lib/index.less";
import "./vantUI/theme.less";
import "vant/lib/icon/local.css";
import preventReClick from "./common/preventReClick.js";
import "@/js/loggerHelper";
//fontawesome icon
import "@/js/fontAwesomeHelper";

import "@csstools/normalize.css";
import "@/style/all.css";

import { isTestMode } from "./common/testConfig.js";
//自测定义一个全局的测试变量
Vue.prototype.isTestMode = isTestMode();

Vue.use(infiniteScroll);
// VUE use
Vue.use(Loading);
// or with options
Vue.use(Loading, {
  isFixed: true, // 是否固定位置，默认为true
  isComponent: true, // 是否自动注册为全局组件，如果设置为false就不会注册成组件来使用
  isShowAnimation: true // 是否显示动画效果，默认为true
});

Vue.use(VueCropper);

Vue.config.productionTip = false;
// Install BootstrapVue
Vue.use(BootstrapVue);
// Optionally install the BootstrapVue icon components plugin
Vue.use(IconsPlugin);

/* eslint-disable no-new */
Vue.use(Vuex);
Vue.prototype.$md5 = md5;

router.beforeEach((to, from, next) => {
  if (to.meta.title) {
    document.title = to.meta.title;
  }
  next();
});

//徽商银行
const moduleHsBank = {
  namespaced: true,
  state: {
    reuploadCount: 0
  },
  mutations: {
    reuploadImg(state) {
      //是否进行重新上传卡面操作
      console.log("reuploadImg");
      state.reuploadCount++;
      console.log(state);
    },
    decreReuploadImg(state) {
      console.log("decreReuploadImg");
      if (state.reuploadCount > 0) {
        state.reuploadCount--;
      }
      console.log(state);
    },
    resetState(state) {
      console.log("resetState");
      state.reuploadCount = 0;
      console.log(state);
    }
  }
};

// 襄阳公交
const moduleXyBus = {
  namespaced: true,
  state: {
    reuploadCount: 0
  },
  mutations: {
    reuploadImg(state) {
      //是否进行重新上传卡面操作
      console.log("reuploadImg");
      state.reuploadCount++;
      console.log(state);
    },
    decreReuploadImg(state) {
      console.log("decreReuploadImg");
      if (state.reuploadCount > 0) {
        state.reuploadCount--;
      }
      console.log(state);
    },
    resetState(state) {
      console.log("resetState");
      state.reuploadCount = 0;
      console.log(state);
    }
  }
};
// 襄阳公交
const moduleZzBus = {
  namespaced: true,
  state: {
    reuploadCount: 0
  },
  mutations: {
    reuploadImg(state) {
      //是否进行重新上传卡面操作
      console.log("reuploadImg");
      state.reuploadCount++;
      console.log(state);
    },
    decreReuploadImg(state) {
      console.log("decreReuploadImg");
      if (state.reuploadCount > 0) {
        state.reuploadCount--;
      }
      console.log(state);
    },
    resetState(state) {
      console.log("resetState");
      state.reuploadCount = 0;
      console.log(state);
    }
  }
};
// 泰州公交
const moduleTaiBus = {
  namespaced: true,
  state: {
    reuploadCount: 0
  },
  mutations: {
    reuploadImg(state) {
      //是否进行重新上传卡面操作
      console.log("reuploadImg");
      state.reuploadCount++;
      console.log(state);
    },
    decreReuploadImg(state) {
      console.log("decreReuploadImg");
      if (state.reuploadCount > 0) {
        state.reuploadCount--;
      }
      console.log(state);
    },
    resetState(state) {
      console.log("resetState");
      state.reuploadCount = 0;
      console.log(state);
    }
  }
};

// 洪城通
const module_hongcheng = {
  namespaced: true,
  state: {
    reuploadCount: 0
  },
  mutations: {
    reuploadImg(state) {
      //是否进行重新上传卡面操作
      console.log("reuploadImg");
      state.reuploadCount++;
      console.log(state);
    },
    decreReuploadImg(state) {
      console.log("decreReuploadImg");
      if (state.reuploadCount > 0) {
        state.reuploadCount--;
      }
      console.log(state);
    },
    resetState(state) {
      console.log("resetState");
      state.reuploadCount = 0;
      console.log(state);
    }
  }
};
// 青岛农商行
const module_qingdao = {
  namespaced: true,
  state: {
    reuploadCount: 0
  },
  mutations: {
    reuploadImg(state) {
      //是否进行重新上传卡面操作
      console.log("reuploadImg");
      state.reuploadCount++;
      console.log(state);
    },
    decreReuploadImg(state) {
      console.log("decreReuploadImg");
      if (state.reuploadCount > 0) {
        state.reuploadCount--;
      }
      console.log(state);
    },
    resetState(state) {
      console.log("resetState");
      state.reuploadCount = 0;
      console.log(state);
    }
  }
};

//齐鲁银行
const moduleQlBank = {
  namespaced: true,
  state: {
    reuploadCount: 0
  },
  mutations: {
    reuploadImg(state) {
      //是否进行重新上传卡面操作
      console.log("reuploadImg-ql");
      state.reuploadCount++;
      console.log(state, "ql");
    },
    decreReuploadImg(state) {
      console.log("decreReuploadImg-ql");
      if (state.reuploadCount > 0) {
        state.reuploadCount--;
      }
      console.log(state, "ql");
    },
    resetState(state) {
      console.log("resetState-ql");
      state.reuploadCount = 0;
      console.log(state, "ql");
    }
  }
};

//齐商银行
const moduleQsBank = {
  namespaced: true,
  state: {
    reuploadCount: 0
  },
  mutations: {
    reuploadImg(state) {
      //是否进行重新上传卡面操作
      console.log("reuploadImg-qs");
      state.reuploadCount++;
      console.log(state, "qs");
    },
    decreReuploadImg(state) {
      console.log("decreReuploadImg-qs");
      if (state.reuploadCount > 0) {
        state.reuploadCount--;
      }
      console.log(state, "qs");
    },
    resetState(state) {
      console.log("resetState-qs");
      state.reuploadCount = 0;
      console.log(state, "qs");
    }
  }
};

const store = new Vuex.Store({
  modules: {
    hs: moduleHsBank,
    ql: moduleQlBank,
    qs: moduleQsBank,
    xy: moduleXyBus,
    zz: moduleZzBus,
    tai:moduleTaiBus,
    qingdao: module_qingdao,
    hongcheng:module_hongcheng
  }
});

new Vue({
  el: "#app",
  store: store,
  router,
  components: {
    App
  },
  template: "<App/>"
});



// WEBPACK FOOTER //
// ./src/main.js